import * as StoryletActionTypes from 'actiontypes/storylet';

import { INITIAL_STATE } from 'reducers/storylet/constants';

import chooseBranchSuccess from './chooseBranchSuccess';
import clearCache from './clearCache';
import fetchAvailableSuccess from './fetchAvailableSuccess';
import renameQualitySuccess from './renameQualitySuccess';
import sortEligibleFriends from './sortEligibleFriends';


/**
 * Storylet
 * @param {Object} state
 * @param {[Object]} action
 */
export default function reducer(state = INITIAL_STATE, action) {
  const { payload = {} } = action;

  switch (action.type) {
    case StoryletActionTypes.CLEAR_CACHE:
      return clearCache(state);

    case StoryletActionTypes.CHOOSE_STORYLET_REQUESTED:
      return { ...state, isChoosing: true };

    case StoryletActionTypes.CHOOSE_STORYLET_FAILURE:
      return {
        ...state,
        isChoosing: false,
        phase: payload.phase || state.phase,
      };

    case StoryletActionTypes.CHOOSE_STORYLET_SUCCESS:
      return {
        ...state,
        isChoosing: false,
        phase: payload.phase,
        storylet: payload.storylet,
        endStorylet: payload.endStorylet,
        messages: payload.messages,
      };

    case StoryletActionTypes.FETCH_AVAILABLE_REQUESTED:
      return { ...state, isFetching: true };

    // This is here to remind us that it's not omitted. If the app is doing
    // a background fetch of available storylets, then we shouldn't set
    // isFetching to true (the UI is being updated separately)
    case StoryletActionTypes.FETCH_AVAILABLE_IN_BACKGROUND_REQUESTED:
      return state;

    case StoryletActionTypes.FETCH_AVAILABLE_FAILURE:
      return {
        ...state,
        isFetching: false,
        // TODO: previously we set phase: action.phase, which will always
        // evaluate to undefined. I'm not sure what the implications are for this,
        // but we probably shouldn't clobber phase like that on a network failure
        // phase: action.phase
      };

    case StoryletActionTypes.FETCH_AVAILABLE_SUCCESS:
      return fetchAvailableSuccess(state, payload);

    case StoryletActionTypes.GOBACK_REQUESTED:
      return { ...state, isGoingBack: true };

    case StoryletActionTypes.GOBACK_FAILURE:
      return {
        ...state,
        isGoingBack: false,
        // TODO: action.phase will always evaluate to undefined on GOBACK_FAILURE.
        // Do we really want to set that?
        // phase: action.phase || state.phase,
      };

    case StoryletActionTypes.GOBACK_SUCCESS:
      return {
        ...state,
        isGoingBack: false,
        phase: payload.phase,
        storylet: null,
      };

    case StoryletActionTypes.CHOOSE_BRANCH_REQUESTED:
      return { ...state, isChoosing: true };

    case StoryletActionTypes.CHOOSE_BRANCH_FAILURE:
      return {
        ...state,
        isChoosing: false,
        phase: action.phase,
      };

    case StoryletActionTypes.CHOOSE_BRANCH_SUCCESS:
      return chooseBranchSuccess(state, payload);

    case StoryletActionTypes.SEND_SOCIAL_INVITATION_REQUESTED:
      return { ...state, isFetching: true };

    case StoryletActionTypes.SEND_SOCIAL_INVITATION_FAILURE:
      return { ...state, isFetching: false };

    case StoryletActionTypes.SEND_SOCIAL_INVITATION_SUCCESS:
      return {
        ...state,
        isFetching: false,
        phase: payload.phase,
        // TODO: WTF?
        storylet: payload.phase === 'End' ? null : state.storylet,
        endStorylet: payload.endStorylet,
        externalSocialAct: payload.externalSocialAct,
        messages: payload.messages,
      };

    case StoryletActionTypes.FETCH_INELIGIBLE_CONTACTS_SUCCESS:
      return {
        ...state,
        ineligibleContacts: action.ineligibleContacts,
      };

    case StoryletActionTypes.CREATE_PLAN_FAILURE:
      return { ...state, isFetching: action.isFetching };

    case StoryletActionTypes.ADD_NEW_CONTACT_REQUESTED:
      return { ...state, isSaving: true };

    case StoryletActionTypes.ADD_NEW_CONTACT_FAILURE:
      return { ...state, isSaving: false };

    case StoryletActionTypes.ADD_NEW_CONTACT_SUCCESS:
      return {
        ...state,
        isSaving: false,
        message: payload.message,
        eligibleFriends: [...payload.eligibleFriends].sort(sortEligibleFriends),
        addedFriendId: payload.addedFriendId,
      };

    case StoryletActionTypes.RENAME_QUALITY_REQUESTED:
    case StoryletActionTypes.RENAME_QUALITY_FAILURE:
      return {
        ...state,
        isRenaming: action.isRenaming,
      };

    case StoryletActionTypes.RENAME_QUALITY_SUCCESS:
      return renameQualitySuccess(state, payload);

    case StoryletActionTypes.RESET_MAP_UPDATED:
      return {
        ...state,
        mapUpdated: false,
      };

    case StoryletActionTypes.BEGIN_SOCIAL_EVENT_REQUESTED:
    case StoryletActionTypes.BEGIN_SOCIAL_EVENT_FAILURE:
      return {
        ...state,
        // phase: action.phase,
        isFetching: action.isRenaming,
      };

    case StoryletActionTypes.BEGIN_SOCIAL_EVENT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        messages: action.messages,
        phase: action.phase,
        // storylets: action.storylets,
        // phase: action.phase,
        storylet: action.storylet,
        // endStorylet: action.endStorylet
      };

    case StoryletActionTypes.GO_BACK_FROM_SOCIAL_ACT:
      return {
        ...state,
        phase: action.phase,
        socialAct: null,
      };

    case StoryletActionTypes.PUT_IN:
      return { ...state, phase: 'In' };


    case StoryletActionTypes.CANNOT_USE_QUALITY:
      return {
        ...state,
        cannotUseMessage: action.cannotUseMessage,
      };

    case StoryletActionTypes.CLOSE_CANNOTUSE_DIALOG:
      return {
        ...state,
        cannotUseMessage: null,
      };

    default:
      return state;
  }
}

// export default Storylet;
